import { render } from "./Destructions.vue?vue&type=template&id=641d945c"
import script from "./Destructions.vue?vue&type=script&lang=js"
export * from "./Destructions.vue?vue&type=script&lang=js"

import "./Destructions.vue?vue&type=style&index=0&id=641d945c&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__